module.exports = __webpack_public_path__ + "img/14.98f71fa7.png";